import React from 'react';
import {
  LinkField,
  RichTextField,
  TextField,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import {
  FilterValuePropertyFromFields,
  mapWithoutValueProperty,
} from 'src/utils/mapWithoutValueProperty';

import { CongestionReportsOverview as CongestionReportsOverviewComponent } from 'src/components/CongestionReportsOverview';

export type CongestionReportsOverviewProps = {
  fields: {
    title: TextField;
    text: RichTextField;
    congestionTypeLabel: TextField;
    provinceLabel: TextField;
    statusLabel: TextField;
    searchLabel: TextField;
    dateFilterLabel: TextField;
    detailWildcardPage?: LinkField;
  };
} & ComponentProps;

export type FilteredCongestionReportsOverviewProps = FilterValuePropertyFromFields<
  CongestionReportsOverviewProps['fields']
>;

const CongestionReportsOverview = (props: CongestionReportsOverviewProps) => {
  if (props.fields) {
    const fields = mapWithoutValueProperty(props.fields);

    return <CongestionReportsOverviewComponent {...fields} />;
  }
};

export default withDatasourceCheck()<CongestionReportsOverviewProps>(CongestionReportsOverview);
